import React from 'react';

function DropGuideArea({ offsetX = 0, offsetY = 0, width = 10, height = 10 }) {
  return (
    <div
      className="ws-drop-guide-area"
      style={{
        transform: `translate(${offsetX}px, ${offsetY}px)`,
        height,
        width,
      }}
    />
  );
}

export default DropGuideArea;
